import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { track } from '../../analytics/utils';
import {
  Box,
  Carousel,
  Center,
  Circle,
  Grid,
  InteractiveSpan,
  InteractiveText,
  Margin,
  Media,
  Padding,
  Stack,
  Text,
} from '../../components';
import { MeetTheTeamData } from './shared';

const TextWrapper = styled.div<any>`
  width: 100%;
  text-align: ${({ alignment }: any) => alignment || 'left'};
`;

const MappedMeetTheTeamComponent = (props) => {
  let { startingIndex, endingIndex, columns } = props;
  return (
    <div>
      <Grid columns={columns}>
        {_.flow(
          (MeetTheTeamData) =>
            _.map(MeetTheTeamData, (value, index) => {
              return (
                <Margin size={[0, 0, 4, 0]} key={index}>
                  <Center>
                    <Circle size={9}>
                      <Box ratio={1} backgroundImage={value?.image} />
                    </Circle>
                  </Center>
                </Margin>
              );
            }),
          (MeetTheTeamData) =>
            _.slice(MeetTheTeamData, startingIndex, endingIndex)
        )(MeetTheTeamData)}
      </Grid>
      <Grid columns={columns}>
        {_.flow(
          (MeetTheTeamData) =>
            _.map(MeetTheTeamData, (value, index) => {
              return (
                <Text textType="primary1" key={index}>
                  {value?.name}
                </Text>
              );
            }),
          (MeetTheTeamData) =>
            _.slice(MeetTheTeamData, startingIndex, endingIndex)
        )(MeetTheTeamData)}
      </Grid>
      <Grid columns={columns}>
        {_.flow(
          (MeetTheTeamData) =>
            _.map(MeetTheTeamData, (value, index) => {
              return (
                <TextWrapper key={index}>
                  <Text textType="primary1">{value?.position}</Text>
                  <Text textType="primary2">{value?.description}</Text>
                  <TextWrapper alignment="center">
                    <InteractiveSpan
                      align="center"
                      textType="primary2"
                      opacity={0.5}
                      underlined
                      onClick={() => {
                        track(`Meet the Team`, {
                          name: value?.name?.split(' ')[0],
                        });
                        window.open(value?.url);
                      }}
                    >
                      Meet {value?.name?.split(' ')[0]}
                    </InteractiveSpan>
                  </TextWrapper>
                </TextWrapper>
              );
            }),
          (MeetTheTeamData) =>
            _.slice(MeetTheTeamData, startingIndex, endingIndex)
        )(MeetTheTeamData)}
      </Grid>
    </div>
  );
};

export const MeetTheTeamTablet = () => {
  return (
    <Padding size={[6]}>
      <Stack size={6}>
        <Text textType="heading3">Meet the Team</Text>
        <Carousel buttoned duration={0}>
          <MappedMeetTheTeamComponent
            startingIndex={0}
            endingIndex={3}
            columns={3}
          />
          <MappedMeetTheTeamComponent
            startingIndex={3}
            endingIndex={MeetTheTeamData.length}
            columns={3}
          />
        </Carousel>
      </Stack>
    </Padding>
  );
};
